import { render, staticRenderFns } from "./CoozzyInfoIcon.vue?vue&type=template&id=41183e8b&scoped=true"
import script from "./CoozzyInfoIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyInfoIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyInfoIcon.vue?vue&type=style&index=0&id=41183e8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41183e8b",
  null
  
)

export default component.exports